module.exports = __webpack_public_path__ + "static/media/Helsedirektoratetlogo.94e62850.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Helsedirektoratetlogo.jpg
// module id = 5754
// module chunks = 0